"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Class to add or remove any metrics library providers. Also specifies method
 * to record a given event
 */
var ARTMetricsPlatform = /** @class */ (function () {
    function ARTMetricsPlatform() {
        this.eventTypeToProviderNamesMap = new Map();
        this.registeredProviders = new Map();
        this.defaultMetricsProviders = [];
        this.defaultProviderNameSet = new Set();
    }
    ARTMetricsPlatform.prototype.setDefaultMetricsProviders = function (defaultMetricsProviders) {
        if (defaultMetricsProviders.length) {
            for (var _i = 0, defaultMetricsProviders_1 = defaultMetricsProviders; _i < defaultMetricsProviders_1.length; _i++) {
                var defaultProvider = defaultMetricsProviders_1[_i];
                var defaultProviderName = defaultProvider.getName();
                if (defaultProviderName) {
                    if (this.defaultProviderNameSet.has(defaultProviderName)) {
                        console.warn(defaultProviderName + " already present in the list of default providers list");
                    }
                    else {
                        this.defaultProviderNameSet.add(defaultProviderName);
                        this.defaultMetricsProviders.push(defaultProvider);
                    }
                }
            }
        }
        else {
            this.defaultProviderNameSet.clear();
            this.defaultMetricsProviders = [];
        }
    };
    /**
     * This method would send the event to the individual metrics providers for it
     * to be recorded in the providers registered for the event type.
     *
     * @param {IEvent} event - Event to be recorded
     */
    ARTMetricsPlatform.prototype.record = function (event) {
        var eventData = event.getEventData();
        var eventType = eventData.eventType;
        var providers = this.getProviders(eventType);
        if (providers.length) {
            for (var _i = 0, providers_1 = providers; _i < providers_1.length; _i++) {
                var provider = providers_1[_i];
                provider.recordEvent(event);
            }
        }
        else {
            console.warn("No metrics provider found for event type " + eventType);
            console.log("Event recorded is " + JSON.stringify(event.getEventData(), undefined, 2));
        }
    };
    /**
     * This method would return all the registered provider for the given event type
     *
     * @param eventType - type of the event you want to retrieve the providers
     * return {array[object]} - returns the registered providers list
     */
    ARTMetricsPlatform.prototype.getProviders = function (eventType) {
        var _this = this;
        var providerNames = this.eventTypeToProviderNamesMap.get(eventType);
        var providers = [];
        Array.prototype.push.apply(providers, this.defaultMetricsProviders);
        if (providerNames) {
            providerNames.forEach(function (providerName) {
                var provider = _this.registeredProviders.get(providerName);
                if (provider && !_this.defaultProviderNameSet.has(providerName)) {
                    providers.push(provider);
                }
            });
        }
        return providers;
    };
    /**
     * This method would send the given event type and metric provider to the
     * platform for being registered.
     *
     * @param {string | EventType} - eventType
     * @param [object] providerName - List of providers
     */
    ARTMetricsPlatform.prototype.addProvidersToEventType = function (eventType, providers) {
        var _this = this;
        var registeredProviderNames = this.eventTypeToProviderNamesMap.get(eventType) || new Set();
        providers.forEach(function (provider) {
            var providerName = provider.getName();
            if (!providerName) {
                return console.error("Unable to add provider to Event type as there is no Name found for the provider");
            }
            if (registeredProviderNames.has(providerName)) {
                console.warn(providerName + " already present to " + eventType + " event type. We will override it");
            }
            registeredProviderNames.add(providerName);
            _this.registeredProviders.set(providerName, provider);
            console.log(provider.getName() + " provider is added to " + eventType + " event type");
        });
        this.eventTypeToProviderNamesMap.set(eventType, registeredProviderNames);
    };
    /**
     *
     * This method would send the given event type and metric provider to the
     * platform for being unregistered.
     *
     * @param {string | EventType} eventType
     * @param {Array<string>} providers
     */
    ARTMetricsPlatform.prototype.removeProvidersFromEventType = function (eventType, providers) {
        var _this = this;
        var registeredProviderNames = this.eventTypeToProviderNamesMap.get(eventType) || new Set();
        providers.forEach(function (provider) {
            var providerName = typeof provider === "string" ? provider : provider.getName();
            if (!registeredProviderNames.has(providerName)) {
                return console.error("Unable to remove provider from event type as it is not present");
            }
            registeredProviderNames.delete(providerName);
            _this.registeredProviders.delete(providerName);
            console.log(providerName + " provider is remove for " + eventType + " event type");
        });
        this.eventTypeToProviderNamesMap.set(eventType, registeredProviderNames);
    };
    return ARTMetricsPlatform;
}());
exports.ARTMetricsPlatform = ARTMetricsPlatform;
var ARTWebMetrics = new ARTMetricsPlatform();
exports.default = ARTWebMetrics;
//# sourceMappingURL=art-metrics-platforms.js.map